import { FormattedMessage, useIntl } from 'react-intl';
import { InputText } from '../Inputs/InputText';
import { FormElement } from '../FormElement';
import { FieldError, useFormContext } from 'react-hook-form';
import { FormSection } from '../FormSection';
import { SchemaType } from '@/hooks/useStudentFormSchema';
import { HelpTooltip } from '@/components/core/HelpTooltip';
import { EMAIL_DESCRIPTION } from '@/components/Import/fieldsLegendData';

type StudentFormType =
  | SchemaType<'create' | 'update', 'transportation'>
  | SchemaType<'create' | 'update', 'child-and-youth'>;

interface PersonalInformationProps {
  editMode: boolean;
  onClickButton: () => void;
  canEdit?: boolean;
}

export const StudentInformation = ({
  editMode,
  onClickButton,
  canEdit,
}: PersonalInformationProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<StudentFormType>();

  const { formatMessage } = useIntl();

  return (
    <FormSection
      title={<FormattedMessage defaultMessage="Profil" />}
      onClickButton={onClickButton}
      editMode={editMode}
      canSeeButton={canEdit}
    >
      <div className="flex flex-col gap-2">
        <FormElement
          id="first_name"
          label={<FormattedMessage defaultMessage="Förnamn" />}
          required={editMode}
          input={
            <InputText
              name="first_name"
              control={control}
              editMode={editMode}
              error={errors.first_name as FieldError}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="last_name"
          label={<FormattedMessage defaultMessage="Efternamn" />}
          required={editMode}
          input={
            <InputText
              name="last_name"
              control={control}
              editMode={editMode}
              error={errors.last_name as FieldError}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="national_identity_number"
          label={<FormattedMessage defaultMessage="Personnummer" />}
          required={editMode}
          input={
            <InputText
              name="national_identity_number"
              control={control}
              editMode={editMode}
              error={errors.national_identity_number as FieldError}
              placeholder={formatMessage({ defaultMessage: 'ÅÅÅÅMMDD-XXXX' })}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="email"
          label={<FormattedMessage defaultMessage="E-post" />}
          labelHint={<HelpTooltip text={EMAIL_DESCRIPTION} />}
          input={
            <InputText
              name="email"
              control={control}
              editMode={editMode}
              error={errors.email as FieldError}
              helperTextReserveSpace
            />
          }
        />
      </div>
    </FormSection>
  );
};
